import {Component, OnInit, ViewChild} from '@angular/core';
import { MatLegacyAutocomplete as MatAutocomplete } from '@angular/material/legacy-autocomplete';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {startWith, map} from 'rxjs/operators';
import {IdexService} from 'app/idex.service';
import {Toast} from 'app/shared/toast/toast';
import {TranslateService} from '@ngx-translate/core';

declare let $: any;
let message;

@Component({
   selector: 'app-new-group',
   templateUrl: './new-group.component.html',
   styleUrls: ['./new-group.component.css']
})
export class NewGroupComponent implements OnInit {
   backButton;
   viewMode = false;
   contactOpt: any;
   errorMessage: any;
   isAddGroup = true;
   groupIdvalue = '';
   groupNamevalue = '';
   groupContvalue: any;
   groups: GroupData[];
   members: Contact[] = [];
   contacts: Contact[];
   myControl = new FormControl();
   requireInputMessage: string;
   error: any;
   userData: User[] = [];
   @ViewChild(MatAutocomplete) matAutocomplete: MatAutocomplete;

   constructor(public toast: Toast,
               public service: IdexService, public translate: TranslateService,
               private dialogRef: MatDialogRef<NewGroupComponent>) {
   }

   ngOnInit() {
      if (!this.viewMode) {
         this.translate.get('cancel').subscribe((msg) => {
            this.backButton = msg;
         });
      } else {
         this.translate.get('signOff.close').subscribe((msg) => {
            this.backButton = msg;
         });
      }
      this.service.getContact()
         .subscribe((data: any) => {
            this.contacts = data;
         }, error => {
            this.errorMessage = error;
         });
      this.translate.get('alert.inputRequired').subscribe((msg) => {
         this.requireInputMessage = msg;
         message = msg;
      });


      $('#form input[type=text]').on('change invalid', function () {
         const textfield = $(this).get(0);

         textfield.setCustomValidity('');
         if (!textfield.validity.valid) {
            textfield.setCustomValidity(message);
         }
      });
   }

   validMessage(input: any) {
      const value = input.value.trim();
      if (/[<|>\\\/:?*"%^{}[\]]/g.test(value)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.error = s;
         });
         return;
      } else {
         this.translate.get('null').subscribe(s => {
            this.error = s;
         });
      }
   }

   selectKeyPress(event) {
      if (event.key === 'Enter') {
         return;
      }
   }

   highlightFirstOptionUser(event, input: any): void {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
         return;
      }
      const kw = input.trim();
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(kw)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         if (kw.length > 0) {
            this.service.getContactAll(0, 0, '', '', encodeURIComponent(kw), 't')
               .subscribe(
                  dataContact => {
                     this.service.getContactAllShare(0, 0, '', '', encodeURIComponent(kw), 't')
                        .subscribe(
                           dataShare => {
                              this.userData = dataContact;
                              dataShare.forEach(value=>this.userData.push(value));
                              this.matAutocomplete._keyManager.setFirstItemActive();
                           }, error => {
                              this.errorMessage = error;
                           });
                  }, error => {
                     this.errorMessage = error;
                  });
            
         } else {
            this.userData = [];
         }
      }
   }

   filter(keyword: string): Contact[] {
      return this.contacts.filter(contact =>
         contact.fullName.toLowerCase().indexOf(keyword.toLowerCase()) === 0
         || contact.email.toLowerCase().indexOf(keyword.toLowerCase()) === 0);
   }

   displayFn(contact?: Contact): string | undefined {
      return '';
   }

   selectContact(evt: any, contactOpt: any, cont: any): void {
      if (evt.source && evt.source.selected && cont.value !== '') {
         let isExist = false;
         for (let i = 0; i < this.members.length; i++) {
            if (this.members[i].contactId === contactOpt.value.contactId) {
               isExist = true;
               break;
            }
         }
         if (!isExist) {
            this.members.push(contactOpt.value);
         }
         contactOpt.value = [];
      }
   this.userData = [];
   }

   deleteMember(member: any) {
      const index: number = this.members.indexOf(member);
      if (index !== -1) {
         this.members.splice(index, 1);
      }
   }

   addGroup(id: any, groupName: any) {
      const value = groupName.value.trim();
      if (/[<|>\\\/:?*"%^{}[\]]/g.test(value)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.error = s;
         });
         return;
      } else {
         const gId = id.value;
         const gName = groupName.value;
         const listMember = this.members;
         const memberIdList: number[] = [];
         for (let i = 0; i < listMember.length; i++) {
            memberIdList.push(listMember[i].contactId);
         }
         if (gId === '') {
            this.service.addGroup(0, gName, memberIdList)
               .subscribe((response) => {
                  this.dialogRef.close(true);
                  this.toast.success(response);
               });
         } else {
            this.service.updateGroup(gId, gName, memberIdList)
               .subscribe((response) => {
                  this.dialogRef.close(true);
                  this.toast.success(response);
               });
         }
      }
   }
}

export interface GroupData {
   groupId: number;
   no: number;
   groupName: string;
   active: boolean;
}
export class User {
   constructor(public id: number, public fullName: string, public email: string, public name: string) {
   }
}

export class Contact {
   constructor(public contactId: number, public fullName: string, public email: string) {
   }
}
